import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// components
import MainHeader from "../../components/Header/MainHeader";
import SelectOption from "../../components/Select/SelectOption";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { addWorkExperience } from "../../redux/slices/registerSlice";
import { googleEvent_LOJ075 } from "../../lib/google-analytics";
import { googleEvent_LOJ073 } from "../../lib/google-analytics-loan-journey-events";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function WorkExperience() {
  const [loading, setLoading] = useState(false);

  const { workExperience } = useSelector((state) => state.register);
  const { repeatCustomer } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const { incompleteDetailsUpdate } = new ServicesAPI();
  const { handleStep } = useResponse();

  const data = ["0 - 2 Years", "2 - 5 Years", "5 - 8 Years", "8 - 10 Years", "More than 10 years"];

  const handleIncompleteDetailsUpdateAPI = async (data) => {
    setLoading(true);
    const res = await incompleteDetailsUpdate(data, repeatCustomer);

    if (res) {
      dispatch(addWorkExperience(data.value));
      handleStep();
    }

    setLoading(false);
  };

  useEffect(() => {
    googleEvent_LOJ073();
  }, []);

  useEffect(() => {
    if(loading) {
      handleShowContextualLoader("Please wait...");
      return;
    } else {
      handlehideContextualLoader();
    }
    return () => {
      handlehideContextualLoader();
    };
  }, [loading]);

  return (
    <>
      <div className="wrapper">
        <MainHeader title="Employment Details" showProgress={true} percent={76.9} />
        <div className="mb-3">
          <p className="label">Work Experience</p>
        </div>

        {data.map((item, index) => (
          <div
            key={index}
            onClick={async () => {
              handleIncompleteDetailsUpdateAPI({
                key: "totalExperience",
                value: item,
              });

              // Events
              googleEvent_LOJ075(item);
            }}
          >
            <SelectOption name={item} checked={workExperience} />
          </div>
        ))}

        <br />
      </div>
    </>
  );
}
